import type { ReactNode } from 'react';
import { cn } from '@/lib/utils';

interface ContainerCardProps {
  children?: ReactNode;
  fontSize?: string;
  fontWeight?: string;
  borderRadius?: string;
  boxShadow?: string;
  backgroundColor?: string;
  padding?: string;
  color?: string;
  gap?: string;
  className?: string;
}

const ContainerCard = ({
  children,
  fontSize,
  fontWeight = '700',
  borderRadius = 'var(--border-radius)',
  boxShadow = 'var(--box-shadow)',
  backgroundColor = 'var(--neutral-50)',
  padding = '20px',
  color = 'var(--black)',
  gap = '20px',
  className = '',
}: ContainerCardProps) => {
  return (
    <div
      className={cn('container-card my-[20px]', className)}
      style={{
        fontSize,
        fontWeight,
        borderRadius,
        boxShadow,
        backgroundColor,
        padding,
        color,
        gap,
      }}
    >
      {children}
    </div>
  );
};

export default ContainerCard;
